import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import api from "../../api"
import { CreateSurchargeRequest, UpdateSurchargeRequest } from "../../api/pricing.api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import ConfirmModal from "../../components/Common/ConfirmModal"
import { RootState } from "../../store"
import {
    createSurcharge,
    deleteSurcharge,
    loadSurcharges,
    resetSurchargeSuccess,
    updateSurcharge
} from "../../store/pricing.store"
import Header from "../Layout/Header"
import SurchargeModal from "./SurchargeModal"
// import DateRangePickerCustom from "components/Common/DateRangePicker/DateRangePickerCustom";
import SurchargesTable from "./SurchargesTable"

const Surcharges = () => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { userInfo, defaultWarehouse } = useAppSelector((state: RootState) => state.auth)
    const {
        surcharges,
        surchargeLoading,
        error: apiError,
        surchargeSuccess
    } = useAppSelector((state: RootState) => state.pricing)
    const { selectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)

    const [surchargeDetails, setSurchargeDetails] = useState({} as Record<string, any>)
    const [show, setShow] = useState("")
    const [shippingServices, setShippingServices] = useState([] as Record<string, any>[])
    const [error, setError] = useState("")
    const [surchargeSearch, setSurchargeSearch] = useState({} as Record<string, any>)

    const [errors, setErrors] = useState({} as Record<string, any>)
    useEffect(() => {
        dispatch(
            loadSurcharges({
                shippingCompanyId: surchargeSearch?.shipping_company_id,
                shippingServiceId: surchargeSearch?.shipping_service_id
            })
        )
    }, [JSON.stringify(surchargeSearch)])

    const getShippingServices = async () => {
        try {
            const res = await api.pricing.listShippingServices(selectedWarehouse || defaultWarehouse)
            if (res?.data?.status) {
                setShippingServices(res?.data?.payload)
            } else {
                setError(res?.error || res?.message || "")
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (shippingServices?.length === 0 && (selectedWarehouse !== 0 || defaultWarehouse !== 0)) {
            getShippingServices()
        }
    }, [shippingServices?.length, selectedWarehouse, defaultWarehouse])

    const handleSubmit = async (surchargeDetails: Record<string, any>) => {
        if (surchargeDetails?.id) {
            await dispatch(
                updateSurcharge({ existingSurchargeData: surchargeDetails as UpdateSurchargeRequest })
            )
        } else {
            await dispatch(createSurcharge({ newSurchargeData: surchargeDetails as CreateSurchargeRequest }))
        }
        // setSurchargeSearch({
        //     shipping_service_id: "",
        //     shipping_company_id: "",
        //     date: ""
        // })
    }

    useEffect(() => {
        if (surchargeSuccess) {
            setSurchargeDetails({})
            if (
                (surchargeSearch?.shipping_company_id && surchargeSearch?.shipping_company_id !== "") ||
                (surchargeSearch?.shipping_service_id && surchargeSearch?.shipping_service_id !== "")
            ) {
                dispatch(
                    loadSurcharges({
                        shippingCompanyId: surchargeSearch?.shipping_company_id,
                        shippingServiceId: surchargeSearch?.shipping_service_id
                    })
                )
            } else {
                dispatch(loadSurcharges({}))
            }

            setShow("")
            dispatch(resetSurchargeSuccess())
        }
    }, [surchargeSuccess])

    return (
        <>
            {(!error && surchargeLoading) || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="surcharges-container">
                    <Header
                        title={t("Pricing / Surcharges")}
                        records={surcharges?.length}
                        data={surcharges}
                        name="Surcharge"
                        //buttonId="#surchargesExportButton"
                    >
                        <div className="mx-2">
                            {/*<DateRangePickerCustom setStartDate={setStartDate} setEndDate={setEndDate} />*/}
                        </div>
                    </Header>
                    <div className="row justify-content-end px-5 mt-3">
                        <Button
                            className="col-2"
                            onClick={() => {
                                setSurchargeDetails({})
                                setErrors({})
                                setShow("editOrCreateModal")
                            }}>
                            {t("Add Surcharge")}
                        </Button>
                    </div>

                    <SurchargesTable
                        surcharges={surcharges}
                        surchargeDetails={surchargeDetails}
                        setSurchargeDetails={setSurchargeDetails}
                        setErrors={setErrors}
                        setShow={setShow}
                        surchargeSearch={surchargeSearch}
                        setSurchargeSearch={setSurchargeSearch}
                    />

                    <SurchargeModal
                        loading={surchargeLoading}
                        show={show}
                        setShow={setShow}
                        surchargeDetails={surchargeDetails}
                        setSurchargeDetails={setSurchargeDetails}
                        handleClose={() => setShow("")}
                        handleSubmit={handleSubmit}
                        shippingServices={shippingServices}
                        errors={errors}
                        setErrors={setErrors}
                    />
                    <ConfirmModal
                        show={show}
                        data={surchargeDetails?.id || {}}
                        handleClose={() => {
                            setSurchargeDetails({})
                            setShow("")
                        }}
                        handleSubmit={(id: number) => {
                            dispatch(deleteSurcharge(id))
                            setShow("")
                        }}
                        title={"Delete Surcharge"}
                    />
                </div>
            )}
        </>
    )
}

export default Surcharges
